module.exports = __webpack_public_path__ + "static/fonts/iconfont.05d6ae13.ttf";